// extracted by mini-css-extract-plugin
module.exports = {"floatingButton":"MobileFloatingButton_floatingButton__2CqIB"};